import { render, staticRenderFns } from "./practiceList.vue?vue&type=template&id=5ded1c94&scoped=true"
import script from "./practiceList.vue?vue&type=script&lang=js"
export * from "./practiceList.vue?vue&type=script&lang=js"
import style0 from "../css/practiceList.scss?vue&type=style&index=0&id=5ded1c94&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ded1c94",
  null
  
)

export default component.exports